import { utils } from "@/utils/utils";
import gql from "graphql-tag";
import Vue from "vue";
import Component from "vue-class-component";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { STATUS, User } from "@/models/common-interface/common.interface";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import { renewalFormApi } from "@/providers/apis/renewal-application";
import { ADDITIONAL_RENEWAL_SUPERVISOR_FORM_QUERY } from "@/graphql/additional-renewal-supervisor-form-query";
import { additionalSupervisor } from "@/models/renewal-form/renewal-form.interface";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";

@Component({
  name: "additional-renewal-supervisor",
  components: {
    AppLoaderComponent,
    ErrorPopupComponent,
    "b-form-radio-group": RadioButtonComponent,
  },
})
export default class AdditionalRenewalSupervisorFormComponent extends Vue {
  public isScroll = false;
  public formTitle = {
    program_title: "",
    application_name: "",
  };
  public isLoading = true;
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    avoidNumbersAndSpecialChar: this.avoidNumbersAndSpecialCharacter,
    telCharacter: this.telCharacterValidate,
  };
  public mainId = "app";
  public applicationData: any = {};
  public supervisorPayLoadData: any[] = [];
  public supervisorEmailDuplicateIndexs: number[] = [];
  public checkValidForm = false;
  public supervisorFormFields: additionalSupervisor[] = [];
  public userDetails: User = {} as User;
  public rejectedEmails: string[] = [];
  public routeQuery: any;
  public token = "";
  public errorMessage = "";
  public alreadySubmittedEmails: string[] = [];
  public alreadySubmittedEmailIdx: number[] = [];
  public hideDiv: string[] = ["startDate", "endDate"];
  public checkField: string[] = ["currentlyEmployed"];

  public async created() {
    this.userDetails = utils.getUserDetails();
    this.routeQuery = this.$route.query;
    this.token = this.routeQuery?.token;
    await renewalFormApi
      .getRenewalSupervisorLists(this.token)
      .then(async (supervisorLists: any) => {
        supervisorLists.employeeSummaries.map((data: any) => {
          this.alreadySubmittedEmails.push(data.email.toLowerCase());
          if (
            data.status === STATUS.notAccepted &&
            data.notificationStatus === "NOTIFICATION_SENT"
          ) {
            this.rejectedEmails.push(data.email.toLowerCase());
          }
        });
        await this.$apollo
          .query({
            query: gql`query ${ADDITIONAL_RENEWAL_SUPERVISOR_FORM_QUERY}`,
          })
          .then((result) => {
            this.applicationData =
              result.data.additionalRenewalSupervisorForms.data;
            this.formTitle = {
              program_title: this.applicationData[0].attributes.program_title,
              application_name:
                this.applicationData[0].attributes.application_name,
            };
            for (let index = 0; index < this.rejectedEmails.length; index++) {
              if (this.supervisorPayLoadData.length) {
                this.supervisorFormFields.push(
                  this.applicationData[0].attributes.form_fields.formInputs[0]
                );
                this.supervisorPayLoadData.push({
                  supervisorFirstName: "",
                  supervisorLastName: "",
                  peerSupportAgencyOrganization: "",
                  peerSupportYourPosition: "",
                  currentlyEmployed: "",
                  startDate: "",
                  endDate: "",
                  supervisorCredentials: "",
                  phone: "",
                  supervisorEmail: "",
                  descripePeerSupportResponsibity: "",
                });
              } else {
                this.supervisorPayLoadData = [
                  {
                    supervisorFirstName: "",
                    supervisorLastName: "",
                    peerSupportAgencyOrganization: "",
                    peerSupportYourPosition: "",
                    currentlyEmployed: "",
                    startDate: "",
                    endDate: "",
                    supervisorCredentials: "",
                    phone: "",
                    supervisorEmail: "",
                    descripePeerSupportResponsibity: "",
                  },
                ];
                this.supervisorFormFields = [
                  this.applicationData[0].attributes.form_fields.formInputs[0],
                ];
              }
            }
            this.isLoading = false;
          });
        for (let index = 0; index < this.checkField.length; index++) {
          this.fieldUpdate(this.checkField[index]);
        }
      })
      .catch((error) => {
        this.isLoading = false;
        this.errorMessage = utils.errorMessage(error);
        this.$bvModal.show("error-modal-center");
        setTimeout(() => {
          this.$bvModal.hide("error-modal-center");
        }, 3000);
      });
  }

  public addAnother() {
    this.supervisorPayLoadData.push({
      supervisorFirstName: "",
      supervisorLastName: "",
      peerSupportAgencyOrganization: "",
      peerSupportYourPosition: "",
      currentlyEmployed: "",
      startDate: "",
      endDate: "",
      supervisorCredentials: "",
      phone: "",
      supervisorEmail: "",
      descripePeerSupportResponsibity: "",
    });
    this.supervisorFormFields.push(
      this.applicationData[0].attributes.form_fields.formInputs[0]
    );
  }

  public removeSupervisor(indexForm: number) {
    this.supervisorPayLoadData.splice(indexForm, 1);
    this.supervisorFormFields.splice(indexForm, 1);
  }

  public onSubmit() {
    this.checkValidForm = true;
    this.$validator.validate().then(async (validate) => {
      // Email duplicate validation
      this.supervisorEmailDuplicateIndexs = utils.duplicateValueIdx(
        this.supervisorPayLoadData,
        "",
        true,
        "supervisorEmail"
      );

      if (this.supervisorEmailDuplicateIndexs.length) {
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 50);
      }

      // check already submitted email validation
      this.supervisorPayLoadData.map((data, idx) => {
        if (
          this.alreadySubmittedEmails.includes(
            data.supervisorEmail.toLowerCase()
          )
        ) {
          if (!this.alreadySubmittedEmailIdx.includes(idx)) {
            this.alreadySubmittedEmailIdx.push(idx);
          }
        } else {
          if (this.alreadySubmittedEmailIdx.includes(idx)) {
            const position = this.alreadySubmittedEmailIdx.findIndex(
              (data) => data === idx
            );
            this.alreadySubmittedEmailIdx.splice(position);
          }
        }
      });

      const decodeToken = JSON.parse(atob(this.token.split(".")[1]));
      const duplicateEmail = this.supervisorPayLoadData.filter(
        (supervisor: any) => {
          if (
            supervisor.supervisorEmail.toLowerCase() ===
            decodeToken.email.toLowerCase()
          ) {
            return supervisor;
          }
        }
      );
      if (duplicateEmail.length) {
        this.errorMessage =
          "Applicant email id and supervisor email id must be different *";
        return;
      }

      if (
        this.supervisorEmailDuplicateIndexs.length === 0 &&
        validate &&
        this.alreadySubmittedEmailIdx.length === 0
      ) {
        this.isLoading = true;
        for (
          let index = 0;
          index < this.supervisorPayLoadData.length;
          index++
        ) {
          if (this.supervisorPayLoadData[index].isNewAdded) {
            delete this.supervisorPayLoadData[index].isNewAdded;
          }
        }
        renewalFormApi
          .addAdditionalRenewalSupervisor(
            this.supervisorPayLoadData,
            this.token
          )
          .then((data) => {
            const someData = {
              title: "Certified Family Support Specialist Program",
              SubTitle: "Additional Supervisor",
            };
            this.$router.push({
              path: "/form/submitted",
              query: {
                subTitle: someData.SubTitle,
              },
            });
            window.scrollTo(0, 0);
            this.isLoading = false;
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
            this.$bvModal.show("error-modal-center");
            setTimeout(() => {
              this.$bvModal.hide("error-modal-center");
            }, 3000);
          });
      } else {
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 50);
      }
    });
  }

  public numberValidation(evt: any, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public fieldValidation(
    value: any,
    eventName: string,
    fieldType: string,
    maxLength = 0
  ) {
    if (fieldType === "number") {
      this.eventBind[eventName](value, maxLength);
    } else {
      this.eventBind[eventName](value);
    }
  }

  public emptyEvent() {
    return;
  }

  public closePopup() {
    this.$bvModal.hide("error-modal-center");
  }

  public fieldUpdate(groupName = "") {
    switch (groupName) {
      case "currentlyEmployed":
        if (this.supervisorPayLoadData[0].currentlyEmployed === "No") {
          if (this.hideDiv.indexOf("endDate") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("endDate"), 1);
          }
          if (this.hideDiv.indexOf("startDate") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("startDate"), 1);
          }
        } else if (this.supervisorPayLoadData[0].currentlyEmployed === "Yes") {
          if (!this.hideDiv.includes("endDate")) {
            this.hideDiv.push("endDate");
            this.supervisorPayLoadData[0].endDate = "";
          }
          if (this.hideDiv.indexOf("startDate") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("startDate"), 1);
          }
        }
        break;
    }
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }
}
